var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorreo24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9C1.25 5.82436 3.82436 3.25 7 3.25H17C20.1756 3.25 22.75 5.82436 22.75 9V15C22.75 18.1756 20.1756 20.75 17 20.75H7C3.82436 20.75 1.25 18.1756 1.25 15V9ZM7 4.75C4.65279 4.75 2.75 6.65279 2.75 9V15C2.75 17.3472 4.65279 19.25 7 19.25H17C19.3472 19.25 21.25 17.3472 21.25 15V9C21.25 6.65279 19.3472 4.75 17 4.75H7Z",
    fill: "#88919E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 8.55C5.64853 8.21863 6.11863 8.15147 6.45 8.4L11.25 12C11.6944 12.3333 12.3056 12.3333 12.75 12L17.55 8.4C17.8814 8.15147 18.3515 8.21863 18.6 8.55C18.8485 8.88137 18.7814 9.35147 18.45 9.6L13.65 13.2C12.6722 13.9333 11.3278 13.9333 10.35 13.2L5.55 9.6C5.21863 9.35147 5.15147 8.88137 5.4 8.55Z",
    fill: "#88919E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo24X24);
export default __webpack_public_path__ + "static/media/CORREO_24X24.82f5266203539b90854704fea2b9c147.svg";
export { ForwardRef as ReactComponent };